// The sealy account-page shell shared by the profile-edit / change-password /
// address-book documents: the capped-width wrapper, the "Your Account / ..."
// breadcrumbs, and the page heading. Crumbs render as links when they
// carry an href, plain text otherwise, joined by " / " like the legacy
// breadcrumbs markup.
import { Immutable } from "immer";
import React from "react";

import { AccountBreadcrumbs, ICrumb } from "../AccountBreadcrumbs";

type IProps = Immutable<{
    crumbs: ICrumb[];
    heading: string;
}> & {
    children?: React.ReactNode;
};

export const AccountBreadcrumbShell = (props: IProps): React.JSX.Element => (
    <div className="l-capped-width">
        <AccountBreadcrumbs crumbs={props.crumbs} />

        <header>
            <h2>{props.heading}</h2>
        </header>

        {props.children}
    </div>
);
